import Home from "../../../jsx/components/Dashboard/Home";

const HomeWrapper = () => {
  return <Home />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.admin];

export default constore(HomeWrapper);
